import { Link } from "react-router-dom";


export default function CTA() {
    return (
        <section className="max-w-7xl mx-auto px-6 py-20">
            <div className="bg-gradient-to-br from-[#1e1b4b] to-[#7c3aed] rounded-3xl text-center text-white px-6 py-16">
                <h2 className="text-4xl md:text-5xl font-extrabold mb-4">
                    Ready to bring your idea to life?
                </h2>
                <p className="text-indigo-100 max-w-xl mx-auto mb-8">
                    Join thousands of innovators building the future of Andhra
                    Pradesh's product economy.
                </p>
                <div className="flex flex-wrap gap-4 justify-center">

                    <Link to="/register" className="bg-white text-indigo-900 font-semibold px-6 py-3 rounded-xl hover:bg-gray-100 transition">
                        Start Your Prototype
                    </Link>

                    <a href="#dashboard"
                        className="border border-white/30 font-semibold px-6 py-3 rounded-xl hover:bg-white/10 transition"
                    >
                        See Innovator Dashboard
                    </a>
                </div>
            </div>
        </section>
    );
}